import { render, staticRenderFns } from "./MultiQuestion.vue?vue&type=template&id=0a9b000e&scoped=true&"
import script from "./MultiQuestion.vue?vue&type=script&lang=js&"
export * from "./MultiQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MultiQuestion.vue?vue&type=style&index=0&id=0a9b000e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b000e",
  null
  
)

export default component.exports